import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "../src/App"; // Ensure you're using the correct import path
import { store } from "@store/store";
import { Provider } from "react-redux";
// import TagManager from 'react-gtm-module'

import { addGoogleAnalytics } from "@utilities/googleAnalytics";
import { initFacebookPixel } from "@utilities/facebookPixel"; 
import { addHotjar } from "@utilities/hotjar";
import { addLinkedInPixel } from "@utilities/linkedin";



const campaignData = window.__INITIAL_DATA__ || {
    success: false,
    message: "No campaign data available",
    data: {},
};

const rootElement = document.getElementById("root")!;
if (rootElement) {
    addGoogleAnalytics();
    initFacebookPixel();
    addHotjar();
    addLinkedInPixel();


    ReactDOM.hydrateRoot(
        rootElement,
        <Provider store={store}>
            <BrowserRouter basename= "/donor-management">
                <App campaignData={campaignData} />
            </BrowserRouter>
        </Provider>
    );
}

